import React, { useEffect, useRef } from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  pdf,
} from "@react-pdf/renderer";

import { Button } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import logo from "./savationChristLogo.png";

/* -------------------------------------------------------------------------- */
/*                                  STYLES                                    */
/* -------------------------------------------------------------------------- */

const MAROON = "#6e3700";
const BLUE = "#1d4ed8";
const LIGHT = "#f8fafc";
const BORDER = "#cbd5e1";
const DARK = "#1e293b";
const GRAY = "#64748b";

const styles = StyleSheet.create({
page: {
    paddingTop: 12,
    paddingBottom: 16,
    paddingHorizontal: 12,
    backgroundColor: "#fff",
    fontFamily: "Helvetica",
},

  pageTitle: {
    textAlign: "center",
    fontSize: 18,
    color: "#111827",
    fontWeight: "bold",
    marginBottom: 12,
  },

  wrapper: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },

card: {
  width: "49%",
  border: "1 solid #d1d5db",
  borderRadius: 4,
  padding: 7,
  backgroundColor: "#fff",
},

  /* ----------------------------- HEADER ----------------------------- */

header: {
    flexDirection: "row",
    borderBottom: "1 solid #d1d5db",
    paddingBottom: 5,
    marginBottom: 5,
    alignItems: "center",
},

  logo: {
width:42,
height:42,
    marginRight: 10,
  },

  schoolInfo: {
    flex: 1,
  },

schoolName: {
    color: "#111827",
    fontSize: 15,
    fontWeight: "bold",
  },

  schoolAddress: {
    fontSize: 8,
    color: GRAY,
    marginTop: 1,
  },

  reportTitle: {
    marginTop: 4,
    fontSize: 10,
    color: BLUE,
    fontWeight: "bold",
  },

  /* -------------------------- STUDENT INFO -------------------------- */

infoBox: {
    
    borderBottom: "2 solid #7f1d1d",
    backgroundColor: "#fafafa",
    padding: 5,
    borderRadius: 3,
    marginBottom: 5,
},

  infoRow: {
    flexDirection: "row",
    marginBottom: 3,
  },

  label: {
    width: 72,
    fontSize: 8,
    color: DARK,
    fontWeight: "bold",
  },

  value: {
    flex: 1,
    fontSize: 8,
    color: DARK,
  },

  /* --------------------------- TABLE --------------------------- */

  table: {
    width: "100%",
    border: "1 solid #cbd5e1",
    marginTop: 4,
  },

  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#e2e8f0",
    borderBottom: "1 solid #cbd5e1",
    paddingVertical: 3,
  },

headerSubject: {
  width: "75%",
  textAlign: "left",
  fontSize: 8,
  fontWeight: "bold",
  paddingLeft: 5,
  color: DARK,
  borderRight: "1 solid #cbd5e1",
},

headerScore: {
  width: "25%",
  textAlign: "center",
  fontSize: 8,
  fontWeight: "bold",
  color: DARK,
},

tableRow: {
  flexDirection: "row",
  borderBottom: "1 solid #e2e8f0",
  minHeight: 16,
  alignItems: "center",
},

subjectCell: {
  width: "75%",
  paddingLeft: 5,
  fontSize: 8,
  color: DARK,
  borderRight: "1 solid #cbd5e1",
  paddingVertical: 3,
},

scoreCell: {
  width: "25%",
  textAlign: "center",
  fontSize: 8,
  fontWeight: "bold",
  paddingVertical: 3,
},

  scoreGood: {
    color: BLUE,
  },

  scoreBad: {
    color: "#dc2626",
  },

  /* ------------------------- SUMMARY ------------------------- */

summaryBox: {
    marginTop:5,
    padding:4,
    border:"1 solid #d1d5db",
    backgroundColor:"#fafafa",
},

  summaryRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 4,
  },

  summaryLabel: {
    fontSize: 8,
    fontWeight: "bold",
    color: DARK,
  },

  summaryValue: {
    fontSize: 8,
    color: BLUE,
    fontWeight: "bold",
  },

  /* ---------------------- SIGNATURES ---------------------- */

  signatures: {
    marginTop: 10,
    flexDirection: "row",
    justifyContent: "space-between",
  },

  signatureBox: {
    width: "42%",
    alignItems: "center",
  },

  signatureLine: {
    width: "100%",
    borderTop: "1 solid #000",
    marginBottom: 4,
  },

  signatureText: {
    fontSize: 8,
    color: DARK,
  },

  /* ----------------------- FOOTER ----------------------- */

  footer: {
    marginTop: 6,
    borderTop: "1 solid #cbd5e1",
    paddingTop: 5,
    textAlign: "center",
    fontSize: 7,
    color: "#666",
  },
});

/* -------------------------------------------------------------------------- */
/*                            HELPER FUNCTIONS                                */
/* -------------------------------------------------------------------------- */

const isLowScore = (score) => {
  if (typeof score === "number") {
    return score < 70;
  }

  if (typeof score === "string") {
    return ["D", "F"].includes(score.toUpperCase());
  }

  return false;
};

const getScoreStyle = (score) =>
  isLowScore(score) ? styles.scoreBad : styles.scoreGood;


const groupReports = (reports = []) => {
  const pages = [];

  for (let i = 0; i < reports.length; i += 2) {
    pages.push(reports.slice(i, i + 2));
  }

  return pages;
};



const StudentGradeCard = ({ report }) => {
  const subjects = report.student_subjects || [];

  return (
    <View style={styles.card}>
      {/* ============================ HEADER ============================ */}

      <View style={styles.header}>
        <Image src={logo} style={styles.logo} />

        <View style={styles.schoolInfo}>
          <Text style={styles.schoolName}>
            Salvation In Christ School System
            {/* Jana L. Williams Educational Foundation */}
            
           
          </Text>

          <Text style={styles.schoolAddress}>
            1st Cowfield Junction, Paynesville City, Monrovia, Liberia
            {/* Mt. Barclay New Store Community, Monrovia Liberia */}
             {/* Zazay Community, Paynesville City, Monrovia */}
            {/* LPMC By Pass Community Ganta city, Nimba county. */}
          </Text>

          <Text style={styles.schoolAddress}>
            {/* Monrovia, Liberia */}
          </Text>

          <Text style={styles.schoolAddress}>
            Tel: +231-727-2609 / +231-886-484-807
          </Text>

          <Text style={styles.reportTitle}>
            STUDENT PERIODIC REPORT
          </Text>
        </View>
      </View>

      {/* ======================== STUDENT INFORMATION ======================= */}

      <View style={styles.infoBox}>
        <View style={styles.infoRow}>
          <Text style={styles.label}>Student:</Text>
          <Text style={styles.value}>
            {report.student_name}
          </Text>
        </View>

        <View style={styles.infoRow}>
          <Text style={styles.label}>Grade:</Text>
          <Text style={styles.value}>
            {report.grade_class_name}
          </Text>
        </View>

        <View style={styles.infoRow}>
          <Text style={styles.label}>Period:</Text>
          <Text style={styles.value}>
            {report.period_name}
          </Text>
        </View>

        {report.academic_year_name && (
          <View style={styles.infoRow}>
            <Text style={styles.label}>Year:</Text>
            <Text style={styles.value}>
              {report.academic_year_name}
            </Text>
          </View>
        )}
      </View>

      {/* ============================ SUBJECT TABLE ============================ */}

      <View style={styles.table}>
        <View style={styles.tableHeader}>
          <Text style={styles.headerSubject}>
            SUBJECT
          </Text>

          <Text style={styles.headerScore}>
            SCORE
          </Text>
        </View>

        {subjects.length > 0 ? (
          subjects.map((subject, index) => (
            <View
              key={index}
              style={styles.tableRow}
            >
              <Text style={styles.subjectCell}>
                {subject.subject_name}
              </Text>

              <Text
                style={[
                  styles.scoreCell,
                  getScoreStyle(subject.formatted_final_score),
                ]}
              >
                {subject.formatted_final_score}
              </Text>
            </View>
          ))
        ) : (
          <View style={styles.tableRow}>
            <Text
              style={{
                width: "100%",
                textAlign: "center",
                fontSize: 8,
                paddingVertical: 8,
              }}
            >
              No Subjects Found
            </Text>
          </View>
        )}
      </View>

      {/* ============================ SUMMARY ============================ */}

      <View style={styles.summaryBox}>
        <View style={styles.summaryRow}>
          <Text style={styles.summaryLabel}>
            Average Score
          </Text>

          <Text
            style={[
              styles.summaryValue,
              getScoreStyle(report.average_score),
            ]}
          >
            {report.average_score}
          </Text>
        </View>

        <View style={styles.summaryRow}>
          <Text style={styles.summaryLabel}>
            Remark
          </Text>

          <Text style={styles.summaryValue}>
            {report.remark}
          </Text>
        </View>

        <View style={styles.summaryRow}>
          <Text style={styles.summaryLabel}>
            Rank
          </Text>

          <Text style={styles.summaryValue}>
            {report.rank || "N/A"}
          </Text>
        </View>
      </View>

      {/* ============================ SIGNATURES ============================ */}

      <View style={styles.signatures}>
        <View style={styles.signatureBox}>
          <View style={styles.signatureLine} />

          <Text style={styles.signatureText}>
            Class Teacher
          </Text>
        </View>

        <View style={styles.signatureBox}>
          <View style={styles.signatureLine} />

          <Text style={styles.signatureText}>
            Principal
          </Text>
        </View>
      </View>

      {/* ============================ FOOTER ============================ */}

      <View style={styles.footer}>
        <Text>
          Generated by Polu Integrated School Management System
        </Text>
      </View>
    </View>
  );
};

/* -------------------------------------------------------------------------- */
/*                          CLASS REPORT PDF DOCUMENT                          */
/* -------------------------------------------------------------------------- */

// const ClassReportDocument = ({
//   reports = [],
//   gradeClass,
//   period,
// }) => {
  export const ClassReportDocument = ({
  reports = [],
  gradeClass,
  period,
}) => {
  const pages = groupReports(reports);

  return (
    <Document
      title={`Class ${gradeClass?.name || ""} ${period?.name || ""}`}
      author="Polu Integrated School Management System"
      subject="Student Periodic Grade Report"
      creator="Polu Integrated School Management System"
      producer="React PDF"
    >
      {pages.map((pageReports, pageIndex) => (
        <Page
          key={pageIndex}
          size="A4"
          orientation="landscape"
          style={styles.page}
        >
          {/* ============================ PAGE TITLE ============================ */}

    

          <Text
            style={{
              textAlign: "center",
              fontSize: 10,
              marginBottom: 10,
              color: "#475569",
            }}
          >
            Class: {gradeClass?.name || ""}
            {"    |    "}
            Period: {period?.name || ""}
          </Text>

          {/* ========================= TWO REPORTS ========================= */}

          <View
            style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "flex-start",
            }}
            >
            {/* LEFT REPORT */}

            <StudentGradeCard
              report={pageReports[0]}
            />

            {/* RIGHT REPORT */}

            {pageReports[1] ? (
              <StudentGradeCard
                report={pageReports[1]}
              />
            ) : (
              <View
                style={{
                  width: "49%",
                }}
              />
            )}
          </View>

          {/* ============================ PAGE FOOTER ============================ */}

          <View
            fixed
            style={{
              position: "absolute",
              left: 20,
              right: 20,
              bottom: 12,
              flexDirection: "row",
              justifyContent: "space-between",
              borderTop: "1 solid #cbd5e1",
              paddingTop: 4,
            }}
          >
            <Text
              style={{
                fontSize: 8,
                color: "#64748b",
              }}
            >
              Polu Integrated School Management System
            </Text>

            <Text
              style={{
                fontSize: 8,
                color: "#64748b",
              }}
              render={({ pageNumber, totalPages }) =>
                `Page ${pageNumber} of ${totalPages}`
              }
            />
          </View>
        </Page>
      ))}
    </Document>
  );
};
/* -------------------------------------------------------------------------- */
/*                              DOWNLOAD BUTTON                               */
/* -------------------------------------------------------------------------- */
const ClassReportPDF = ({
reports,
gradeClass,
period,
onDownloaded,
onError,
}) => {

const hasStartedRef = useRef(false);

useEffect(() => {


if (!reports?.length) {

  hasStartedRef.current = false;

  return;

}

if (hasStartedRef.current) {

  return;

}

hasStartedRef.current = true;


const generateAndDownload = async () => {

  try {

    const blob = await pdf(
      <ClassReportDocument
        reports={reports}
        gradeClass={gradeClass}
        period={period}
      />
    ).toBlob();


    const url =
      URL.createObjectURL(blob);


    const link =
      document.createElement("a");


    link.href = url;


    link.download =
      `Class_${gradeClass?.name}_${period?.name}.pdf`;


    document.body.appendChild(link);


    link.click();


    document.body.removeChild(link);


    setTimeout(() => {

      URL.revokeObjectURL(url);

      onDownloaded?.();

    }, 1000);


  }
  catch(error) {

    console.error(
      "PDF generation failed:",
      error
    );

    onError?.(error);

  }

};


generateAndDownload();

}, [
reports,
gradeClass,
period,
onDownloaded,
onError,
]);

return null;

};

  
export default ClassReportPDF;








// import React, { useEffect, useRef } from "react";
// import {
//   Document,
//   Page,
//   Text,
//   View,
//   Image,
//   StyleSheet,
//   pdf,
// } from "@react-pdf/renderer";

// import { Button } from "antd";
// import { FilePdfOutlined } from "@ant-design/icons";
// import logo from "./savationChristLogo.png";

// /* -------------------------------------------------------------------------- */
// /*                                  STYLES                                    */
// /* -------------------------------------------------------------------------- */

// const MAROON = "#7f1d1d";
// const BLUE = "#1d4ed8";
// const LIGHT = "#f8fafc";
// const BORDER = "#cbd5e1";
// const DARK = "#1e293b";
// const GRAY = "#64748b";

// const styles = StyleSheet.create({
// page: {
//     paddingTop: 12,
//     paddingBottom: 16,
//     paddingHorizontal: 12,
//     backgroundColor: "#fff",
//     fontFamily: "Helvetica",
// },

//   pageTitle: {
//     textAlign: "center",
//     fontSize: 18,
//     color: "#111827",
//     fontWeight: "bold",
//     marginBottom: 12,
//   },

//   wrapper: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     width: "100%",
//   },

// card: {
//   width: "49%",
//   border: "1 solid #d1d5db",
//   borderRadius: 4,
//   padding: 7,
//   backgroundColor: "#fff",
// },

//   /* ----------------------------- HEADER ----------------------------- */

// header: {
//     flexDirection: "row",
//     borderBottom: "1 solid #d1d5db",
//     paddingBottom: 5,
//     marginBottom: 5,
//     alignItems: "center",
// },

//   logo: {
// width:42,
// height:42,
//     marginRight: 10,
//   },

//   schoolInfo: {
//     flex: 1,
//   },

// schoolName: {
//     color: "#111827",
//     fontSize: 15,
//     fontWeight: "bold",
//   },

//   schoolAddress: {
//     fontSize: 8,
//     color: GRAY,
//     marginTop: 1,
//   },

//   reportTitle: {
//     marginTop: 4,
//     fontSize: 10,
//     color: BLUE,
//     fontWeight: "bold",
//   },

//   /* -------------------------- STUDENT INFO -------------------------- */

// infoBox: {
    
//     borderBottom: "2 solid #7f1d1d",
//     backgroundColor: "#fafafa",
//     padding: 5,
//     borderRadius: 3,
//     marginBottom: 5,
// },

//   infoRow: {
//     flexDirection: "row",
//     marginBottom: 3,
//   },

//   label: {
//     width: 72,
//     fontSize: 8,
//     color: DARK,
//     fontWeight: "bold",
//   },

//   value: {
//     flex: 1,
//     fontSize: 8,
//     color: DARK,
//   },

//   /* --------------------------- TABLE --------------------------- */

//   table: {
//     width: "100%",
//     border: "1 solid #cbd5e1",
//     marginTop: 4,
//   },

//   tableHeader: {
//     flexDirection: "row",
//     backgroundColor: "#e2e8f0",
//     borderBottom: "1 solid #cbd5e1",
//     paddingVertical: 3,
//   },

// headerSubject: {
//   width: "75%",
//   textAlign: "left",
//   fontSize: 8,
//   fontWeight: "bold",
//   paddingLeft: 5,
//   color: DARK,
//   borderRight: "1 solid #cbd5e1",
// },

// headerScore: {
//   width: "25%",
//   textAlign: "center",
//   fontSize: 8,
//   fontWeight: "bold",
//   color: DARK,
// },

// tableRow: {
//   flexDirection: "row",
//   borderBottom: "1 solid #e2e8f0",
//   minHeight: 16,
//   alignItems: "center",
// },

// subjectCell: {
//   width: "75%",
//   paddingLeft: 5,
//   fontSize: 8,
//   color: DARK,
//   borderRight: "1 solid #cbd5e1",
//   paddingVertical: 3,
// },

// scoreCell: {
//   width: "25%",
//   textAlign: "center",
//   fontSize: 8,
//   fontWeight: "bold",
//   paddingVertical: 3,
// },

//   scoreGood: {
//     color: BLUE,
//   },

//   scoreBad: {
//     color: "#dc2626",
//   },

//   /* ------------------------- SUMMARY ------------------------- */

// summaryBox: {
//     marginTop:5,
//     padding:4,
//     border:"1 solid #d1d5db",
//     backgroundColor:"#fafafa",
// },

//   summaryRow: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     marginBottom: 4,
//   },

//   summaryLabel: {
//     fontSize: 8,
//     fontWeight: "bold",
//     color: DARK,
//   },

//   summaryValue: {
//     fontSize: 8,
//     color: BLUE,
//     fontWeight: "bold",
//   },

//   /* ---------------------- SIGNATURES ---------------------- */

//   signatures: {
//     marginTop: 10,
//     flexDirection: "row",
//     justifyContent: "space-between",
//   },

//   signatureBox: {
//     width: "42%",
//     alignItems: "center",
//   },

//   signatureLine: {
//     width: "100%",
//     borderTop: "1 solid #000",
//     marginBottom: 4,
//   },

//   signatureText: {
//     fontSize: 8,
//     color: DARK,
//   },

//   /* ----------------------- FOOTER ----------------------- */

//   footer: {
//     marginTop: 6,
//     borderTop: "1 solid #cbd5e1",
//     paddingTop: 5,
//     textAlign: "center",
//     fontSize: 7,
//     color: "#666",
//   },
// });

// /* -------------------------------------------------------------------------- */
// /*                            HELPER FUNCTIONS                                */
// /* -------------------------------------------------------------------------- */

// const isLowScore = (score) => {
//   if (typeof score === "number") {
//     return score < 70;
//   }

//   if (typeof score === "string") {
//     return ["D", "F"].includes(score.toUpperCase());
//   }

//   return false;
// };

// const getScoreStyle = (score) =>
//   isLowScore(score) ? styles.scoreBad : styles.scoreGood;


// const groupReports = (reports = []) => {
//   const pages = [];

//   for (let i = 0; i < reports.length; i += 2) {
//     pages.push(reports.slice(i, i + 2));
//   }

//   return pages;
// };



// const StudentGradeCard = ({ report }) => {
//   const subjects = report.student_subjects || [];

//   return (
//     <View style={styles.card}>
//       {/* ============================ HEADER ============================ */}

//       <View style={styles.header}>
//         <Image src={logo} style={styles.logo} />

//         <View style={styles.schoolInfo}>
//           <Text style={styles.schoolName}>
//             Salvation In Christ School System
//             {/* Frontline Word Family School */}
//           </Text>

//           <Text style={styles.schoolAddress}>
//              Zazay Community, Paynesville City, Monrovia
//             {/* LPMC By Pass Community Ganta city, Nimba county. */}
//           </Text>

//           <Text style={styles.schoolAddress}>
//             {/* Monrovia, Liberia */}
//           </Text>

//           <Text style={styles.schoolAddress}>
//             Tel: +231-770-216-549 / +231-886-484-807
//           </Text>

//           <Text style={styles.reportTitle}>
//             STUDENT PERIODIC REPORT
//           </Text>
//         </View>
//       </View>

//       {/* ======================== STUDENT INFORMATION ======================= */}

//       <View style={styles.infoBox}>
//         <View style={styles.infoRow}>
//           <Text style={styles.label}>Student:</Text>
//           <Text style={styles.value}>
//             {report.student_name}
//           </Text>
//         </View>

//         <View style={styles.infoRow}>
//           <Text style={styles.label}>Grade:</Text>
//           <Text style={styles.value}>
//             {report.grade_class_name}
//           </Text>
//         </View>

//         <View style={styles.infoRow}>
//           <Text style={styles.label}>Period:</Text>
//           <Text style={styles.value}>
//             {report.period_name}
//           </Text>
//         </View>

//         {report.academic_year_name && (
//           <View style={styles.infoRow}>
//             <Text style={styles.label}>Year:</Text>
//             <Text style={styles.value}>
//               {report.academic_year_name}
//             </Text>
//           </View>
//         )}
//       </View>

//       {/* ============================ SUBJECT TABLE ============================ */}

//       <View style={styles.table}>
//         <View style={styles.tableHeader}>
//           <Text style={styles.headerSubject}>
//             SUBJECT
//           </Text>

//           <Text style={styles.headerScore}>
//             SCORE
//           </Text>
//         </View>

//         {subjects.length > 0 ? (
//           subjects.map((subject, index) => (
//             <View
//               key={index}
//               style={styles.tableRow}
//             >
//               <Text style={styles.subjectCell}>
//                 {subject.subject_name}
//               </Text>

//               <Text
//                 style={[
//                   styles.scoreCell,
//                   getScoreStyle(subject.formatted_final_score),
//                 ]}
//               >
//                 {subject.formatted_final_score}
//               </Text>
//             </View>
//           ))
//         ) : (
//           <View style={styles.tableRow}>
//             <Text
//               style={{
//                 width: "100%",
//                 textAlign: "center",
//                 fontSize: 8,
//                 paddingVertical: 8,
//               }}
//             >
//               No Subjects Found
//             </Text>
//           </View>
//         )}
//       </View>

//       {/* ============================ SUMMARY ============================ */}

//       <View style={styles.summaryBox}>
//         <View style={styles.summaryRow}>
//           <Text style={styles.summaryLabel}>
//             Average Score
//           </Text>

//           <Text
//             style={[
//               styles.summaryValue,
//               getScoreStyle(report.average_score),
//             ]}
//           >
//             {report.average_score}
//           </Text>
//         </View>

//         <View style={styles.summaryRow}>
//           <Text style={styles.summaryLabel}>
//             Remark
//           </Text>

//           <Text style={styles.summaryValue}>
//             {report.remark}
//           </Text>
//         </View>

//         <View style={styles.summaryRow}>
//           <Text style={styles.summaryLabel}>
//             Rank
//           </Text>

//           <Text style={styles.summaryValue}>
//             {report.rank || "N/A"}
//           </Text>
//         </View>
//       </View>

//       {/* ============================ SIGNATURES ============================ */}

//       <View style={styles.signatures}>
//         <View style={styles.signatureBox}>
//           <View style={styles.signatureLine} />

//           <Text style={styles.signatureText}>
//             Class Teacher
//           </Text>
//         </View>

//         <View style={styles.signatureBox}>
//           <View style={styles.signatureLine} />

//           <Text style={styles.signatureText}>
//             Principal
//           </Text>
//         </View>
//       </View>

//       {/* ============================ FOOTER ============================ */}

//       <View style={styles.footer}>
//         <Text>
//           Generated by Polu Integrated School Management System
//         </Text>
//       </View>
//     </View>
//   );
// };

// /* -------------------------------------------------------------------------- */
// /*                          CLASS REPORT PDF DOCUMENT                          */
// /* -------------------------------------------------------------------------- */

// const ClassReportDocument = ({
//   reports = [],
//   gradeClass,
//   period,
// }) => {
//   const pages = groupReports(reports);

//   return (
//     <Document
//       title={`Class ${gradeClass?.name || ""} ${period?.name || ""}`}
//       author="Polu Integrated School Management System"
//       subject="Student Periodic Grade Report"
//       creator="Polu Integrated School Management System"
//       producer="React PDF"
//     >
//       {pages.map((pageReports, pageIndex) => (
//         <Page
//           key={pageIndex}
//           size="A4"
//           orientation="landscape"
//           style={styles.page}
//         >
//           {/* ============================ PAGE TITLE ============================ */}

    

//           <Text
//             style={{
//               textAlign: "center",
//               fontSize: 10,
//               marginBottom: 10,
//               color: "#475569",
//             }}
//           >
//             Class: {gradeClass?.name || ""}
//             {"    |    "}
//             Period: {period?.name || ""}
//           </Text>

//           {/* ========================= TWO REPORTS ========================= */}

//           <View
//             style={{
//                 flexDirection: "row",
//                 justifyContent: "space-between",
//                 alignItems: "flex-start",
//             }}
//             >
//             {/* LEFT REPORT */}

//             <StudentGradeCard
//               report={pageReports[0]}
//             />

//             {/* RIGHT REPORT */}

//             {pageReports[1] ? (
//               <StudentGradeCard
//                 report={pageReports[1]}
//               />
//             ) : (
//               <View
//                 style={{
//                   width: "49%",
//                 }}
//               />
//             )}
//           </View>

//           {/* ============================ PAGE FOOTER ============================ */}

//           <View
//             fixed
//             style={{
//               position: "absolute",
//               left: 20,
//               right: 20,
//               bottom: 12,
//               flexDirection: "row",
//               justifyContent: "space-between",
//               borderTop: "1 solid #cbd5e1",
//               paddingTop: 4,
//             }}
//           >
//             <Text
//               style={{
//                 fontSize: 8,
//                 color: "#64748b",
//               }}
//             >
//               Polu Integrated School Management System
//             </Text>

//             <Text
//               style={{
//                 fontSize: 8,
//                 color: "#64748b",
//               }}
//               render={({ pageNumber, totalPages }) =>
//                 `Page ${pageNumber} of ${totalPages}`
//               }
//             />
//           </View>
//         </Page>
//       ))}
//     </Document>
//   );
// };
// /* -------------------------------------------------------------------------- */
// /*                              DOWNLOAD BUTTON                               */
// /* -------------------------------------------------------------------------- */
// const ClassReportPDF = ({
//   reports,
//   gradeClass,
//   period,
//   onDownloaded,
// }) => {

//   const hasStartedRef = useRef(false);

//   useEffect(() => {

//     if (!reports?.length) {
//       hasStartedRef.current = false;
//       return;
//     }

//     if (hasStartedRef.current) {
//       return;
//     }

//     hasStartedRef.current = true;

//     const generateAndDownload = async () => {

//       try {

//         const blob = await pdf(
//           <ClassReportDocument
//             reports={reports}
//             gradeClass={gradeClass}
//             period={period}
//           />
//         ).toBlob();

//         const url = URL.createObjectURL(blob);

//         const link =
//           document.createElement("a");

//         link.href = url;

//         link.download =
//           `Class_${gradeClass?.name}_${period?.name}.pdf`;

//         document.body.appendChild(link);

//         link.click();

//         document.body.removeChild(link);

//         setTimeout(() => {

//           URL.revokeObjectURL(url);

//           onDownloaded?.();

//         }, 1000);

//       }
//       catch(error) {

//         console.error(
//           "PDF generation failed:",
//           error
//         );

//       }

//     };

//     generateAndDownload();

//   }, [
//     reports,
//     gradeClass,
//     period,
//     onDownloaded,
//   ]);

//   return null;
// };
  
// export default ClassReportPDF;